import { render, staticRenderFns } from "./NewsMarquee.vue?vue&type=template&id=f733acdc&scoped=true"
import script from "./NewsMarquee.vue?vue&type=script&lang=js"
export * from "./NewsMarquee.vue?vue&type=script&lang=js"
import style0 from "./NewsMarquee.vue?vue&type=style&index=0&id=f733acdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f733acdc",
  null
  
)

export default component.exports